import React, { useState } from "react";
import images from "../../assets/images/Constant";
import navData from "../../data/navbar.json";
import { Link, NavLink } from "react-router-dom";

import {
  FaFacebookF,
  FaLinkedinIn,
  FaBars,
  FaTimes,
  // FaTwitter,
  // FaYoutube,
} from "react-icons/fa";

const iconMap = {
  facebook: <FaFacebookF />,
  // youtube: <FaYoutube />,
  linkedin: <FaLinkedinIn />,
  // twitter: <FaTwitter />,
};

const Nav = () => {
  const menu = navData?.menu || [];
  const social = navData?.social || [];
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <div className="absolute top-3 sm:top-6 w-full flex justify-center z-50 px-3 sm:px-4">
      <div className="flex w-full max-w-[1100px] flex-col shadow-lg bg-white rounded-sm overflow-hidden lg:flex-row">
        {/* Logo + mobile toggle */}
        <div className="flex items-center justify-between gap-4 px-4 py-3 lg:px-6 lg:pr-12 lg:py-0 lg:justify-start">
          <Link to="/" onClick={closeMobile} className="shrink-0">
            <img
              src={images[navData.logo]}
              alt="logo"
              className="h-10 sm:h-12 lg:h-14 w-auto"
            />
          </Link>

          <button
            type="button"
            className="lg:hidden p-2 text-dark rounded-md hover:bg-gray-100"
            aria-expanded={mobileOpen}
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
            onClick={() => setMobileOpen((o) => !o)}
          >
            {mobileOpen ? <FaTimes className="text-xl" /> : <FaBars className="text-xl" />}
          </button>
        </div>

        {/* Top bar + nav (collapsible on small screens) */}
        <div
          className={`${
            mobileOpen ? "flex" : "hidden"
          } lg:flex flex-1 flex-col border-t border-gray-100 lg:border-t-0`}
        >
          <div className="bg-[#062E39] text-white flex flex-col gap-2 sm:flex-row sm:justify-between sm:items-center px-4 sm:px-6 lg:px-10 py-2 text-xs sm:text-sm">
            <p className="text-center sm:text-left sm:text-base leading-snug">
              {navData?.topbar?.text}
            </p>

            <div className="flex gap-3 justify-center sm:justify-end">
              {social.map((icon, i) => (
                <span key={i} className="text-lg cursor-pointer">
                  {iconMap[icon]}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4 px-4 py-4 lg:flex-row lg:justify-between lg:items-center lg:px-6 lg:py-3 lg:pr-4">
            <ul className="flex flex-col gap-1 font-medium text-dark text-base lg:flex-row lg:gap-8 lg:items-center">
              {menu.map((item, i) => (
                <li key={i}>
                  <NavLink
                    to={item.path}
                    onClick={closeMobile}
                    className={({ isActive }) =>
                      `block py-2 lg:py-0 cursor-pointer ${
                        isActive ? "text-blue-600" : "text-dark"
                      } hover:text-blue-600`
                    }
                  >
                    {item.title}
                  </NavLink>
                </li>
              ))}
            </ul>

            <div className="lg:shrink-0">
              <Link to="/contact" onClick={closeMobile} className="block w-full lg:w-auto">
                <button className="bg-primary flex w-full items-center justify-center gap-3 text-white px-6 py-3 lg:w-auto">
                  {navData?.button?.text}
                  <img src={images[navData?.button?.icon]} alt="" className="w-4 h-4 object-contain" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
